import {
  BranchesOutlined,
  CarOutlined,
  IdcardOutlined,
  LockOutlined,
  LogoutOutlined,
  ProjectOutlined,
  UserOutlined
} from '@/media/antd-icons';
import FileTextIcon from '@/media/icons/file-text.svg?react';
import IconModules from '@/media/icons/filter.svg?react';
import IconLeasing from '@/media/icons/percent.svg?react';
import IconSettings from '@/media/icons/setting.svg?react';
import { ADMIN_ROUTES, ROUTES, getFullAdminRoute } from '@/shared/routes';

export const adminSideBarItems = [
  {
    label: 'На главную',
    key: ROUTES.leasingScoring,
    icon: <LogoutOutlined className="admin-navbar__link-icon" />
  },
  {
    label: 'Пользователи',
    key: getFullAdminRoute(ADMIN_ROUTES.users),
    icon: <UserOutlined className="admin-navbar__link-icon" />
  },
  {
    label: 'Клиенты',
    key: getFullAdminRoute(ADMIN_ROUTES.clients),
    icon: <IdcardOutlined className="admin-navbar__link-icon" />
  },
  {
    label: 'Черный список',
    key: getFullAdminRoute(ADMIN_ROUTES.blackList),
    icon: <LockOutlined className="admin-navbar__link-icon" />
  },
  {
    label: 'Партнеры',
    key: getFullAdminRoute(ADMIN_ROUTES.partners),
    icon: <IconLeasing className="admin-navbar__link-icon" />
  },
  {
    label: 'Филиалы',
    key: getFullAdminRoute(ADMIN_ROUTES.branches),
    icon: <BranchesOutlined className="admin-navbar__link-icon" />
  },
  {
    label: 'Модули',
    key: getFullAdminRoute(ADMIN_ROUTES.modules),
    icon: <IconModules className="admin-navbar__link-icon" />
  },
  {
    label: 'Авто',
    key: getFullAdminRoute(ADMIN_ROUTES.auto),
    icon: <CarOutlined className="admin-navbar__link-icon" />
  },
  {
    label: 'Продукты',
    key: getFullAdminRoute(ADMIN_ROUTES.products),
    icon: <ProjectOutlined className="admin-navbar__link-icon" />
  },
  {
    label: 'Отчеты',
    key: getFullAdminRoute(ADMIN_ROUTES.reports),
    icon: <FileTextIcon className="admin-navbar__link-icon" />
  },
  {
    label: 'Системные настройки',
    key: getFullAdminRoute(ADMIN_ROUTES.systemSettings),
    icon: <IconSettings className="admin-navbar__link-icon" />
  }
];
